module.exports = __webpack_public_path__ + "img/empty.0308c930.png";